import request from "./request";

const ReviewPracticalExamService = {
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/reviewpracticalexam/${id}`, context.token, signal);
    },
    GetByExam: async (id, context, signal) => {
        return await request.sendRequest(`/reviewpracticalexam/exam/${id}`, context.token, signal);
    },
};

export default ReviewPracticalExamService;
